import axios from 'axios'
import config from '../../config/index.js'

const HTTP = axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP.interceptors.request.use(function (config) {
  if (config && config.baseURL.includes('fhabian')) {
    config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt')
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

export default {
  /* GET */
  _get (_url) {
    return HTTP.get(_url)
  },
  /* PUT */
  putRelative (_url, _relative) {
    return HTTP.put(_url, {
      'relative': {
        inviteeId: _relative.inviteeId,
        firstName: _relative.firstName,
        lastName: _relative.lastName,
        alive: _relative.alive,
        familyRelation: _relative.familyRelation,
        familyTreeNode: _relative.familyTreeNode,
        familyTreeParentNode: _relative.familyTreeParentNode
      }
    })
  },
  /* POST */
  _post (_url) {
    return HTTP.post(_url, {})
  },
  postLogin (_url, _cb) {
    return HTTP.post(_url, {
      callbackUrl: _cb
    })
  },
  postRegistration (_url, _registrationData) {
    return HTTP.post(_url, {
      'registrationData': {
        ssn: _registrationData.ssn,
        invitationLink: _registrationData.invitationLink
      }
    })
  },
  postConsent (_url, _consent) {
    return HTTP.post(_url, {
      consent: _consent
    })
  },
  postConsentChild (_url, _childPersonId, _consent) {
    return HTTP.post(_url, {
      childPersonId: _childPersonId,
      consent: _consent
    })
  },
  postMinorConsent (_url, _consent) {
    return HTTP.post(_url, {
      consent: _consent
    })
  },
  postChildrenUnder13 (_url, _hasChildrenUnder13) {
    return HTTP.post(_url, {
      hasChildrenUnder13: _hasChildrenUnder13
    })
  },
  postChildrenbetween13and15 (_url, _careGiver) {
    return HTTP.post(_url, {
      secondaryCaregiverPhoneNumber: _careGiver.phonenumber,
      secondaryCaregiverEmail: _careGiver.email
    })
  },
  postToken (_url, _sessionId) {
    return HTTP.post(_url, {
      sessionID: _sessionId
    })
  },
  postTokenTest (_url, _temp) {
    return HTTP.post(_url, {
      sessionID: _temp.sessionID,
      invitationLink: _temp.invitationLink,
      ssn: _temp.ssn,
      givenName: _temp.givenName,
      surName: _temp.surName
    })
  },
  postInvite (_url, _accept, _invitationLink) {
    return HTTP.post(_url, {
      accept: _accept,
      invitationLink: _invitationLink
    })
  },
  postScreeningAnswer (_url, _answer, _fieldId) {
    return HTTP.post(_url, {
      'answer': _answer,
      'fieldId': _fieldId
    })
  },
  postVerify (_url, _phone, _code) {
    return HTTP.post(_url, {
      phone: _phone,
      code: _code
    })
  },
  postRelative (_url, _relative) {
    return HTTP.post(_url, {
      'relative': {
        firstName: _relative.firstName,
        lastName: _relative.lastName,
        alive: _relative.alive,
        familyRelation: _relative.familyRelation,
        familyTreeNode: _relative.familyTreeNode,
        familyTreeParentNode: _relative.familyTreeParentNode
      }
    })
  },
  postReferral (_url, _labId, _paperReferral) {
    return HTTP.post(_url, {
      labId: _labId,
      paperReferral: _paperReferral
    })
  },
  postReferralHealthCenter (_url, _healthCenter) {
    return HTTP.post(_url, {
      healthCenter: _healthCenter
    })
  },
  /* PATCH, DELETE, OPTIONS etc */
  patchInvites (_url, _invites, _invmsg) {
    return HTTP.patch(_url, {
      'invitation': {
        invites: _invites,
        invitationMessage: _invmsg
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js